import React from 'react'
import { Style } from 'react-style-tag'
import PropTypes from 'prop-types'

const ResetFooter = props => {
  return (
    <Style>{`
          footer.box-footer {
            margin-top: ${props.top ? props.top : '-175px'};
          }
        `}</Style>
  )
}
ResetFooter.propTypes = {
  top: PropTypes.string
}
export default ResetFooter



// WEBPACK FOOTER //
// ./src/App/Footer/ResetFooter.js